"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzButton = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));
var __1 = require("../..");
require("./SzButton.scss");
exports.SzButton = function (_a) {
    var _b = _a.loader, loader = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.alignIcon, alignIcon = _c === void 0 ? 'left' : _c, className = _a.className, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, children = _a.children, onClick = _a.onClick, _e = _a.variant, variant = _e === void 0 ? 'primary' : _e, _f = _a.type, type = _f === void 0 ? 'button' : _f, _g = _a.as, Component = _g === void 0 ? 'button' : _g;
    var buttonClassName = classnames_1.default('btn sz-btn', {
        'btn-primary-brand': !variant || variant === 'primary',
        'btn-primary-light': variant === 'secondary',
        'sz-btn-tertiary': variant === 'tertiary',
        'sz-btn-tertiary-icon': !children
    }, {
        'text-btn-disabled': !variant || (variant === 'primary' && loader),
        'text-white': (variant === 'secondary' && loader) ||
            (variant === 'tertiary' && loader)
    }, className);
    var iconProps = {
        icon: icon,
        variant: 'line',
        className: classnames_1.default({
            'text-disabled': isDisabled,
            'mr-3': children && alignIcon === 'left',
            'ml-3': children && alignIcon === 'right'
        })
    };
    return (react_1.default.createElement(Component, { onClick: onClick, className: buttonClassName, disabled: loader || isDisabled, type: type },
        loader && react_1.default.createElement(__1.SzSpinner, { variant: "dark" }),
        icon && alignIcon === 'left' && (react_1.default.createElement(SzIcon_1.default, __assign({}, iconProps, { key: "sz-button-left-icon" }))),
        children && (react_1.default.createElement(__1.SzTypographie, { key: "sz-button-typo", variant: "button", color: isDisabled ? 'disabled' : undefined, weight: "medium" }, children)),
        icon && alignIcon === 'right' && (react_1.default.createElement(SzIcon_1.default, __assign({}, iconProps, { key: "sz-button-right-icon" })))));
};
exports.default = exports.SzButton;
